import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { adminMainUrl } from "../../../Config.jsx";
import DashIcon from "./DashIcon";
import { actionRequiredItems as fallbackItems } from "./dashboardData";

const severityConfig = {
  critical: { bg: "#FEF2F2", color: "#DC2626", badgeBg: "#FEE2E2" },
  warning: { bg: "#FFFBEB", color: "#D97706", badgeBg: "#FEF3C7" },
  success: { bg: "#F0FDF4", color: "#16A34A", badgeBg: "#DCFCE7" },
  info: { bg: "#EFF6FF", color: "#2563EB", badgeBg: "#DBEAFE" },
};

/**
 * ActionRequired – list of alert/action items with count badges.
 */
const ActionRequired = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchActionRequiredData = async () => {
      const token = Cookies.get('token');
      const user_id = Cookies.get('flexichain_user_id');
      try {
        const response = await fetch(`${adminMainUrl}/api/operation-dashboard-action-required-data`, {
          method: "GET",
          headers: {
            'auth-token': token || '',
            'Authorization': token ? (token.startsWith('Bearer ') ? token : `Bearer ${token}`) : '',
            'user_id': user_id || '',
            'user-id': user_id || '',
            'Content-Type': 'application/json',
          }
        });
        const resData = await response.json();
        if (response.ok && resData?.code === 200) {
          setData(resData.data);
        }
      } catch (err) {
        console.error("Error fetching action required data:", err);
      }
    };

    fetchActionRequiredData();
  }, []);

  const itemsToDisplay = (data || fallbackItems).slice(0, 6);

  return (
    <div className="ops-card ops-action-card">
      <div className="ops-card-header">
        <div className="ops-card-heading">
          <span className="ops-card-heading-icon ops-heading-action">
            <DashIcon type="warning" size={17} color="#fff" />
          </span>
          <span className="ops-card-title">Action Required</span>
        </div>
        <button className="ops-view-all-btn">View All</button>
      </div>

      <div className="ops-action-list">
        {itemsToDisplay.map((item, idx) => {
          const cfg = severityConfig[item.severity] || severityConfig.info;
          return (
            <React.Fragment key={item.id}>
              <div className="ops-action-row">
                <div className="ops-action-left">
                  <span
                    className="ops-action-icon-wrap"
                    style={{ background: cfg.bg }}
                  >
                    <DashIcon type={item.iconType} size={17} color={cfg.color} />
                  </span>
                  <span className="ops-action-label">{item.label}</span>
                </div>
                <span
                  className="ops-action-badge"
                  style={{ background: cfg.badgeBg, color: cfg.color }}
                >
                  {item.count}
                </span>
              </div>
              {idx < itemsToDisplay.length - 1 && (
                <div className="ops-divider" />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default ActionRequired;
